import React, { useEffect, useState } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";
import "./TicketTrendsChart.scss";
import dropicon from  "../../../../../../../Assets/AppComponent/Customersupport_icon/Draganddropicon.svg"
import { useDispatch, useSelector } from "react-redux";
import { clearTicketTrendState , 
  settheDefualtDatefilyer ,
  setTheTicketingsystemtRange1,
  setTheTicketingsystemRange2,

 } from "../../../../../../../Redux/Slice";
import boximg from "../../../../../../../Assets/AppComponent/Group 427320177.svg";
import { isSameMonth, isSameYear, isThisWeek, getWeek, startOfMonth, endOfMonth, format ,startOfToday } from "date-fns";


export default function TicketTrendsChart({
      datas,
  PriorityValues,
  SttausValues,
  Client,
  date,
  setdates,
    setranges,
  setSelectedRange
}) {
  const dispatch = useDispatch();
  const state = useSelector((state)=>state)
   const [showDropdown, setShowDropdown] = useState(false);
  // const [selectedFilter, setSelectedFilter] = useState("Week");

const [selectedFilter, setSelectedFilter] = useState(
  date ? date.replace("This", "") : "Week"
);

      
 useEffect(() => {
  if (date && date !== "") {
    setSelectedFilter(date.replace("This", ""));
  } else {
    setSelectedFilter("Week");
  }
}, [date]);


  const options = ["This Week", "This Month", "This Year"];
// const generateChartData = (ticketData, selectedFilter) => {
//   const today = new Date();
//   let chartData = [];


//  const filteredData = ticketData.filter((item) => {
//   const date = new Date(item.date_range);

//   if (selectedFilter === "Week") {
//     return isThisWeek(date, { weekStartsOn: 0 });
//   }
//   if (selectedFilter === "Month") {
//     return isSameMonth(date, today);
//   }
//   if (selectedFilter === "Year") {
//     return isSameYear(date, today);
//   }
//   return false;
// })

//   const rawData = filteredData.reduce((acc, item) => {
//     const date = new Date(item.date_range);
//     const count = item.ticket_count;

//     if (selectedFilter === "Week") {
//       const key = format(date, "EEE"); // Mon, Tue, ...
//       acc[key] = (acc[key] || 0) + count;
//     }

//     if (selectedFilter === "Month") {
//       const week = `Week ${getWeek(date) - getWeek(startOfMonth(today)) + 1}`;
//       acc[week] = (acc[week] || 0) + count;
//     }

//     if (selectedFilter === "Year") {
//       const month = format(date, "MMM");
//       acc[month] = (acc[month] || 0) + count;
//     }

//     return acc;
//   }, {});

//   if (selectedFilter === "Week") {
//     const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
//     chartData = daysOfWeek.map((day) => ({
//       date: day,
//       tickets: rawData[day] || 0,
//     }));
//   }

//   if (selectedFilter === "Month") {
//     const startWeek = getWeek(startOfMonth(today));
//     const endWeek = getWeek(endOfMonth(today));
//     const weeks = Array.from({ length: endWeek - startWeek + 1 }, (_, i) => `Week ${i + 1}`);
//     chartData = weeks.map((week) => ({
//       date: week,
//       tickets: rawData[week] || 0,
//     }));
//   }

//   if (selectedFilter === "Year") {
//     const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
//     chartData = months.map((month) => ({
//       date: month,
//       tickets: rawData[month] || 0,
//     }));
//   }

//   return chartData;
// };


   const generateChartData = (ticketData, selectedFilter) => {
  const today = new Date();
  let chartData = [];

  const filteredData = ticketData.filter((item) => {
    const date = new Date(item.date_range);

    if (selectedFilter === "Week") {
      return isThisWeek(date, { weekStartsOn: 0 }) && date <= today;
    }
    if (selectedFilter === "Month") {
      return isSameMonth(date, today) && date <= today;
    }
    if (selectedFilter === "Year") {
      return isSameYear(date, today) && date <= today;
    }
    return false;
  });

  const rawData = filteredData.reduce((acc, item) => {
    const date = new Date(item.date_range);
    const count = item.ticket_count;

    if (selectedFilter === "Week") {
      const key = format(date, "EEE"); // Mon, Tue, ...
      acc[key] = (acc[key] || 0) + count;
    }

    if (selectedFilter === "Month") {
      const week = `Week ${getWeek(date) - getWeek(startOfMonth(today)) + 1}`;
      acc[week] = (acc[week] || 0) + count;
    }

    if (selectedFilter === "Year") {
      const month = format(date, "MMM");
      acc[month] = (acc[month] || 0) + count;
    }

    return acc;
  }, {});

  if (selectedFilter === "Week") {
    const startOfWeek = startOfToday();
    const currentDayIndex = today.getDay(); // 0 (Sun) to 6 (Sat)
    const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].slice(0, currentDayIndex + 1);
    chartData = daysOfWeek.map((day) => ({
      date: day,
      tickets: rawData[day] || 0,
    }));
  }

  if (selectedFilter === "Month") {
    const startWeek = getWeek(startOfMonth(today));
    const currentWeek = getWeek(today);
    const weeks = Array.from({ length: currentWeek - startWeek + 1 }, (_, i) => `Week ${i + 1}`);
    chartData = weeks.map((week) => ({
      date: week,
      tickets: rawData[week] || 0,
    }));
  }

  if (selectedFilter === "Year") {
    const currentMonthIndex = today.getMonth(); // 0 (Jan) to 11 (Dec)
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const filteredMonths = months.slice(0, currentMonthIndex + 1);
    chartData = filteredMonths.map((month) => ({
      date: month,
      tickets: rawData[month] || 0,
    }));
  }

  return chartData;
};
  const handleSelect = (option) => {
    setSelectedFilter(option.split(" ")[1]); // Sets "Week", "Month", etc.
                                        dispatch(settheDefualtDatefilyer(option.replace(/\s/g, "")));
                                     dispatch(setTheTicketingsystemtRange1(""));
                                    dispatch(setTheTicketingsystemRange2(""));    
                                   setSelectedRange(null);
                                   setranges(["",""])

                       setdates(option.replace(/\s/g, ""))
                               

    setShowDropdown(false);
  };


  
  useEffect(()=>{
                if(state.ClientBranchIDs.SUBROLE == 3){

  const payload ={
    graph_filter:selectedFilter && selectedFilter.toLowerCase(),
    state:datas?.state,
    region:datas?.region,
    zone:datas?.zone,
     priority:PriorityValues,
     status:SttausValues,
     client:Client
  }
    dispatch(clearTicketTrendState(payload))
}
  },[selectedFilter , datas ,PriorityValues ,SttausValues , Client ])


// const data = state.TicketTrendDashboard.ticketTrendData.map((item) => ({
//   date: new Date(item.date_range).toLocaleDateString("en-GB", {
//     month: "short",
//     year: "numeric",
//   }), 
//   tickets: item.ticket_count,
// }));
const data = generateChartData(state.TicketTrendDashboard.ticketTrendData, selectedFilter);

console.log(data ,"oasidaposid data");



return (
    <div className="ticket-trends-card filter-dropdown">
      <div className="header-trends">
        <h3>Ticket Trends</h3>
     <button
        className="filter-btn "
        onClick={() => setShowDropdown((prev) => !prev)}
      >
        {selectedFilter} <img src={dropicon} alt="filter icon" />
      </button>


      </div>

        {showDropdown && (
        <div className="dropdown-menu_filters">
          {options.map((option) => (
            <div
              key={option}
              className="dropdown-item"
              onClick={() => handleSelect(option)}
            >
              {option}
            </div>
          ))}
        </div>
      )}
        <div className="chart-area" style={{ overflowX: "auto", paddingRight: "16px" }}>
  {data && data.length > 0 ? (
<div style={{ overflowX: "auto", width: "100%",height: "100%" }}>
  <div style={{ minWidth: "600px", paddingRight: "16px", height: "100%" }}>
    <ResponsiveContainer width="100%" height="100%">
      <LineChart data={data}
            margin={{ top: 20, right: 30 }} // Add top and right space
      >
        <CartesianGrid strokeDasharray="5 5" stroke="#ddd" />
        <XAxis dataKey="date" />
        <YAxis />
        <Tooltip
          contentStyle={{
            border: "1px solid #f97316",
            borderRadius: "6px",
            color: "#f97316",
          }}
          labelStyle={{ color: "#333" }}
          formatter={(value) => [`${value} Tickets`, ""]}
        />
        <Line
          type="monotone"
          dataKey="tickets"
          stroke="#f97316"
          strokeWidth={2}
          dot={{ r: 5, fill: "#f97316" }}
          activeDot={{ r: 7 }}
        />
      </LineChart>
    </ResponsiveContainer>
  </div>
</div>

  ) : (
    <div className="Nodatavailable">
      <img src={boximg} alt="No data" />
      No data available
    </div>
  )}
</div>

    </div>
  );
}
